<template>
  <context-alert
    v-if="loading || values.count"
    class="proposals-approved-resume"
    color="success"
    big
    light
    icon="sack-dollar"
  >
    <template v-slot:title>
      {{ total }}
    </template>

    <template
      v-if="!actionless"
      v-slot:action
    >
      <form-button
        :href="more"
        color="highlight"
      >
        Ver todas as aprovadas
      </form-button>
    </template>

    {{ count }}
  </context-alert>
</template>

<script>
  import { mapState } from 'vuex';
  import moment from 'moment';

  import { round } from '@sdk/helpers/formatters/monetize';

  import FormButton from '@cordel/components/Form/Button.vue';
  import ContextAlert from '@cordel/components/Context/Alert.vue';

  const LIMIT = 3;

  export default {
    name: 'ProposalsApprovedResume',
    components: {
      FormButton,
      ContextAlert,
    },
    props: {
      actionless: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        LIMIT,
        more: {
          name: 'proposals-approved',
        },
      };
    },
    computed: {
      ...mapState([
        'proposals',
      ]),

      loading() {
        return this.proposals.values.loading;
      },
      values() {
        // return {
        //   count: 0,
        //   total_in_cents: 0,
        // };

        return this.proposals.values.item;
      },
      total() {
        if (this.loading) {
          return 'Calculando valores...';
        }

        const rounded = round(this.values.total_in_cents);

        return `${rounded} ${/ 1 /.test(rounded) ? 'disponível' : 'disponíveis'} para faturar`;
      },
      count() {
        if (this.loading) {
          return 'Existem propostas aprovadas nos últimos 30 dias esperando por você';
        }

        const i = this.values.count;

        return `${i === 1 ? 'Existe 1 proposta aprovada' : `Existem ${i} propostas aprovadas`} nos últimos 30 dias esperando por você`;
      },
    },
    mounted() {
      this.get();
    },
    methods: {
      get() {
        this.$store
          .dispatch('proposals/values', {
            after: moment().subtract(31, 'days'),
          })
          .then(this.got);
      },
      got() {
        this.$emit('got');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .proposals-approved-resume {
  }
</style>
